import { filter } from 'rxjs/operators';
import { Acabado } from './acabado.model';
import { ColorMaterial } from './color-material.model';
import { Continente } from './continente.model';
import { Espesor } from './espesor.model';
import { TipoMaterial } from './tipo-material.model';
import { UsoMaterial } from './uso-material.model';

export enum FilterKey {
  TIPOLOGIA = 'tipomaterialid',
  ACABADO = 'acabado',
  COLOR = 'colormaterialid',
  USOS = 'usomaterialid',
  ORIGEN = 'origen',
  MEDIDA_ANCHURA = 'largo',
  MEDIDA_ANCHURA_INCHES = 'largoin',
  MEDIDA_ALTURA = 'alto',
  MEDIDA_ALTURA_INCHES = 'altoin',
  MEDIDA_SUPERFICIE = 'superficie',
  MEDIDA_SUPERFICIE_INCHES = 'superficiein',
  ESPESOR = '',
  DISPONIBILIDAD = 'disponibilidad',
  RANGO_PRECIO = 'rangoprecio',
  MATERIAL = 'material',
  BOOKMATCH = 'Libro',
  BLOQUE = 'bloque'
}

export enum FilterType {
  PARENT,
  CHECK_BOX,
  RANGE,
  RANGE_UNIQUE,
  INLINE_CHECK_BOX,
  CUSTOM_VALUE,
  UNIQUE
}

export enum FilterLogicaOperator {
  AND = 'andoperator[]=',
  OR = 'oroperator[]='
}

export enum FilterLogicaOperatorParam {
  AND,
  OR
}

export enum FilterGroupLogicaOperator {
  AND = ' AND ',
  OR = ' OR ',
  CUSTOM = ''
}

export enum FilterComparisonOperator {
  EQUAL = '=',
  NOT_EQUAL = '!=',
  GREATER_THAN = '>',
  GREATER_OR_EQUAL_THAN = '>=',
  LESS_THAN = '<',
  LESS_OR_EQUAL_THAN = '<=',
  CUSTOM = ''
}

export interface Filter {
  type: FilterType;
  name: string;
  logicalOperator: FilterLogicaOperator;
  groupLogicalOperator: FilterGroupLogicaOperator;
  key: FilterKey;
  color?: string;
  comparator?: FilterComparisonOperator;
  checked?: boolean;
  valueMax?: string | number;
  value: string | number;
}

export const FilterIdExtractor: (filter: Filter) => string = fltr => {
  switch(fltr.type){
    case FilterType.RANGE:
      return getRangeKey(fltr.key) + fltr.comparator;
    case FilterType.UNIQUE:
      return getRangeKey(fltr.key);
    case FilterType.CUSTOM_VALUE:
      return fltr.key;
    default :
      return fltr.key + fltr.comparator + fltr.value;
  }
}

export function getRangeKey(key: Filter['key']): string {
  return key.replace(/^min/, '').replace(/^max/, '').replace(/in$/, '')
}

export const getfilterLogicalOperatorParam: (operator: FilterLogicaOperator) => FilterLogicaOperatorParam = operator => {
  if(operator === FilterLogicaOperator.OR) return FilterLogicaOperatorParam.OR
  else return FilterLogicaOperatorParam.AND
}

export const getfilterLogicalOperator: (param: FilterLogicaOperatorParam) => FilterLogicaOperator = param => {
  if(param === FilterLogicaOperatorParam.OR) return FilterLogicaOperator.OR
  else return FilterLogicaOperator.AND
}

export type FilterParam = [
  FilterLogicaOperatorParam,
  FilterGroupLogicaOperator,
  Filter['name'],
  FilterKey,
  FilterComparisonOperator,
  Filter['value'],
  FilterType
]

export type FilterEntity = TipoMaterial | UsoMaterial | Acabado | Continente | ColorMaterial | Espesor;
